module.exports = __webpack_public_path__ + "img/scope-ticket.604d229a.png";